var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        width: "100vw",
        height: "100vh",
        background: "linear-gradient(#005a9f, #1899d6)"
      }
    },
    [
      _c("div", { staticClass: "loginBox" }, [
        _c("img", {
          staticClass: "loginBoxImg",
          attrs: { src: "/dist/logo_login.png" }
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "labels",
            staticStyle: {
              "font-weight": "400",
              "font-size": "23px",
              "margin-bottom": "20px"
            },
            attrs: { id: "titulo" }
          },
          [_vm._v("Venttu Login")]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("p", { staticClass: "labels" }, [_vm._v("USUARIO")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.usuario,
                  expression: "usuario"
                }
              ],
              staticClass: "inputbox login",
              class: { "inputbox login error": _vm.errorUser },
              attrs: { type: "email" },
              domProps: { value: _vm.usuario },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.usuario = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "labels", staticStyle: { "margin-top": "10px" } },
              [_vm._v("CONTRASEÑA")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.pass,
                  expression: "pass"
                }
              ],
              staticClass: "inputbox login",
              class: { "inputbox login error": _vm.errorPass },
              attrs: { type: "password" },
              domProps: { value: _vm.pass },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.pass = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { attrs: { id: "forgetPass" }, on: { click: _vm.btnOlvidePass } },
              [_vm._v("Olvide mi contraseña")]
            ),
            _vm._v(" "),
            _c("div", { attrs: { id: "btnContainer" } }, [
              _c(
                "button",
                { attrs: { id: "btnIngresar" }, on: { click: _vm.btnLogin } },
                [_vm._v("INGRESAR")]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ab7e1f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab7e1f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/login.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7ab7e1f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/login.vue
// module chunks = 0